import { BreadCrumbs } from '@/shared/ui/Breadcrumbs/Breadcrumbs'
import { ClientsView } from '@/widgets/Settings/ClientsView'

export const ClientsPage = () => {
  return (
    <>
      <BreadCrumbs />
      <ClientsView />
    </>
  )
}
